// Dawn には jQuery が無いので DOMContentLoaded で起動する。
// カートページとドロワーの両方に出るため、Dawn がカートを再描画したあとも
// 初期化し直す (ドロワーは innerHTML ごと差し替わり、Pikaday の紐付けが外れる)。
function initDeliveryDatePicker() {
  // 日本語ロケールのときだけ snippets/deliver-date.liquid が UI を出力する。
  // 非表示のページではここで抜ける (getElementById が null になるため)。
  var field = document.getElementById("datePicker");
  if (!field) {
    clearDeliveryAttributes();
    return;
  }

  // 再描画で同じ input に二重に Pikaday が付くのを防ぐ。
  if (field.dataset.deliveryDatePickerReady === "true") {
    return;
  }
  field.dataset.deliveryDatePickerReady = "true";

  // 日本語で入力したあと英語などへ切り替えると cart attribute だけ残り、
  // そのままチェックアウトへ渡る。残存を検出した時だけ空文字で消す。
  function clearDeliveryAttributes() {
    if (!document.querySelector("[data-delivery-date-reset]")) {
      return;
    }
    var root =
      (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";

    // fetch は 4xx/5xx で reject しないので ok を明示的に見る。
    // 失敗しても 1 回だけ再試行し、それ以上は追わない
    // (カートフォーム内の hidden input 側でチェックアウト時に上書きされる)。
    var send = function () {
      return fetch(root + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          attributes: { 配達日: "", 希望配達時間: "", 配達時間指定: "" },
        }),
      }).then(function (res) {
        if (!res.ok) {
          throw new Error("cart/update.js failed: " + res.status);
        }
        return res;
      });
    };

    send()
      .catch(send)
      .catch(function () {
        /* hidden input 側のフォールバックに任せる */
      });
  }

  var pikadayConf = {
    toString: function (date, format) {
      // 出力フォーマット整形 形式「20180101」
      var day = ("0" + date.getDate()).slice(-2);
      var month = ("0" + (date.getMonth() + 1)).slice(-2);
      var year = date.getFullYear();
      var result = year + "-" + month + "-" + day;
      return result;
    },
    maxDate: function () {
      // 表示期間リミット(Date オブジェクト)
      var newDate = new Date();
      var year = newDate.getFullYear() + 1; // 一年後
      var month = newDate.getMonth();
      var date = newDate.getDate();
      return new Date(year, month, date);
    },
    i18n: {
      previousMonth: "前月",
      nextMonth: "次月",
      months: [
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月",
      ],
      weekdays: [
        "日曜日",
        "月曜日",
        "火曜日",
        "水曜日",
        "木曜日",
        "金曜日",
        "土曜日",
      ],
      weekdaysShort: ["日", "月", "火", "水", "木", "金", "土"],
    },
  };

  var minday = new Date();
  minday.setDate(minday.getDate() + 4);

  var datepicker = new Pikaday({
    field: document.getElementById("datePicker"),
    format: "YYYYMMDD",
    toString: pikadayConf.toString,
    minDate: minday,
    maxDate: pikadayConf.maxDate(),
    i18n: pikadayConf.i18n,
    yearSuffix: "年",
    showMonthAfterYear: true,
  });

  const dateInput = document.getElementById("datePicker");
  dateInput.addEventListener("change", function () {
    // 入力された日付をDateオブジェクトに変換
    const inputDate = new Date(this.value);
    const minDate = new Date();
    minDate.setDate(minDate.getDate() + 3);

    // minDateより前なら値をクリアするかエラー表示
    if (inputDate < minDate) {
      alert("指定可能な最短日時より前の日付は選択できません。");
      this.value = "";
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initDeliveryDatePicker);
} else {
  initDeliveryDatePicker();
}

// Dawn のカート更新後に再初期化する。pubsub が無い環境では何もしない。
if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
  subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
    initDeliveryDatePicker();
  });
}
